import { SoapNotesType } from "../../Enums/ChoiceEnums";
import { getJson, getObject, getVoid } from "../ChoiceApi";
import { IPatientSoapNotesItem, ISoapNoteListItem, ISoapNotesCounts } from "../Models/SoapNotes";

export async function ListOpen(user_id: string): Promise<ISoapNoteListItem[]> {
    return (await getJson(`api/SoapNotes/List/Open/${user_id}`)) as ISoapNoteListItem[];
}

export async function ListMissing(user_id: string): Promise<ISoapNoteListItem[]> {
    return (await getJson(`api/SoapNotes/List/Missing/${user_id}`)) as ISoapNoteListItem[];
}

export async function ListAll(user_id: string): Promise<ISoapNoteListItem[]> {
    return (await getJson(`api/SoapNotes/List/All/${user_id}`)) as ISoapNoteListItem[];
}

export async function List(user_id: string, noteType?: SoapNotesType): Promise<ISoapNoteListItem[]> {
    switch (noteType) {
        case SoapNotesType.Open:
            return ListOpen(user_id);

        case SoapNotesType.Missing:
            return ListMissing(user_id);

        default:
            return ListAll(user_id);
    }
}

export async function DashboardCounts(): Promise<ISoapNotesCounts[]> {
    return (await getJson(`api/SoapNotes/Dashboard/Counts`)) as ISoapNotesCounts[];
}

export async function Bypass(appointmentId: number): Promise<boolean> {
    if (appointmentId < 0 || !appointmentId) {
        alert("Invalid appointment ID");
        return false;
    }

    await getVoid(`api/SoapNotes/Bypass/${appointmentId}`);
    return true;
}

export async function patientCompletedSoapNotes(patientId:number, daysSinceEncounter?: number): Promise<IPatientSoapNotesItem[]|undefined> {
    return await getObject<IPatientSoapNotesItem[]>(`api/SoapNotes/Patient/Completed/${patientId}/${daysSinceEncounter ?? ''}`);
}